var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"color":"white"}},[_vm._v("Личный кабинет")]),_vm._v(" "),_c('history'),_vm._v(" "),_c('code-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }